import { callFunction } from "./functions-client";

// Account-to-account connections + the redacted public profile view (ADR-0018).

export interface Connection {
  id: string;
  status: "pending" | "accepted";
  incoming: boolean;
  requester_id: string;
  other_name: string;
  created_at: string;
}

export interface PublicProfile {
  profile: { id: string; type: string; display_name: string | null; headline: string | null; image_url?: string | null; created_at: string; verified: boolean; trust_level?: string; trust_label?: string };
  detail: Record<string, unknown> | null;
  relation: "self" | "admin" | "connection" | "public";
}

export const listConnections = () =>
  callFunction<{ connections: Connection[] }>("connections/list", { method: "GET" });

export const requestConnection = (profile_id: string) =>
  callFunction<{ ok: boolean }>("connections/request", { body: { profile_id } });

export const acceptConnection = (requester_id: string) =>
  callFunction<{ ok: boolean }>("connections/accept", { body: { requester_id } });

export const viewProfile = (id: string) =>
  callFunction<PublicProfile>(`profiles/view?id=${encodeURIComponent(id)}`, { method: "GET" });
